/* eslint-disable */

import React, { useState } from 'react'
// import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { Link, useParams } from 'react-router-dom'
import VideoModal from '../../HomePages/home-one/section/videoModal'
import { all_routes } from '../../router/all_routes'
import { useContentDetail } from '../hooks/useContentDetail'
import { calculateDiscount, rupiahFormatter } from '../../../utils/helpers'
import { benefitsIcons } from '../../../core/common/data/json/benefitsIcon'

function formatDateWithTimeZone(dateString: string) {
  if (!dateString) return ''
  const date = new Date(dateString)
  // Use Asia/Jakarta for WIB
  return new Intl.DateTimeFormat('id-ID', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Asia/Jakarta',
    timeZoneName: 'short',
  })
    .format(date)
    .replace('GMT+7', 'WIB')
}

const CourseDetails = ({ type }: { type: string }) => {
  const [showModal, setShowModal] = useState(false)
  const { id } = useParams<{ id: string }>()

  // Ambil detail course
  const { course, isLoading, isError, error } = useContentDetail({
    id: id || '',
    type,
  })

  const videoUrl = 'https://www.youtube.com/embed/1trvO6dqQUI'

  const handleOpenModal = () => setShowModal(true)
  const handleCloseModal = () => setShowModal(false)

  const route = all_routes

  if (isLoading)
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Loading content...</p>
      </div>
    )
  if (isError)
    return (
      <div className="text-center py-5 text-danger">
        <p>Error loading content: {error?.message || 'Unknown error'}</p>
        <p>Please try again later.</p>
      </div>
    )
  if (!course) return <div>Data course tidak ditemukan.</div>

  return (
    <>
      {/* <Breadcrumb title={course?.title || ''} /> */}
      <>
        {/* Course detail */}
        <section className="course-details-two">
          <div className="container">
            {/* <div className="row">
                <div className="col-12">
                  <div className="card bg-light">
                    <div className="card-body d-lg-flex align-items-center">
                      <div className="position-relative">
                        <Link
                          to="#"
                          id="openVideoBtn"
                          onClick={handleOpenModal}
                        >
                          <ImageWithBasePath
                            className="img-fluid rounded-2"
                            src={
                              course?.image || '/assets/img/course/video-bg.jpg'
                            }
                            fallbackSrc="/assets/img/course/video-bg.jpg"
                            srcApi={course?.image}
                            alt="img"
                          />
                          <div className="play-icon">
                            <i className="ti ti-player-play-filled fs-28" />
                          </div>
                        </Link>
                      </div>
                      <div id="videoModal">
                        <div className="modal-content1">
                          <span className="close-btn" id="closeModal">
                            ×
                          </span>
                          <VideoModal
                            show={showModal}
                            handleClose={handleCloseModal}
                            videoUrl={videoUrl}
                          />
                        </div>
                      </div>
                      <div className="w-100 ps-lg-4">
                        <h3 className="mb-2">{course?.title}</h3>
                        <p className="fs-14 mb-3">
                          {course?.short_description}
                        </p>
                        <div className="d-flex align-items-center gap-2 gap-sm-3 gap-xl-4 flex-wrap my-3 my-sm-0">
                          {course?.type === 'Live_Teaching' && (
                            <p className="fw-medium d-flex align-items-center mb-0">
                              {`${formatDateWithTimeZone(
                                course?.start_date || '',
                              )} - ${formatDateWithTimeZone(
                                course?.end_date || '',
                              )}`}
                            </p>
                          )}
                          {course?.type === 'Course' && (
                            <>
                              <p className="fw-medium d-flex align-items-center mb-0">
                                <ImageWithBasePath
                                  className="me-2"
                                  src="/assets/img/icons/book.svg"
                                  alt="img"
                                />
                                12 Video
                              </p>
                              <p className="fw-medium d-flex align-items-center mb-0">
                                <ImageWithBasePath
                                  className="me-2"
                                  src="/assets/img/icons/timer-start.svg"
                                  alt="img"
                                />
                                9hr 30min
                              </p>
                              <p className="fw-medium d-flex align-items-center mb-0">
                                <ImageWithBasePath
                                  className="me-2"
                                  src="/assets/img/icons/people.svg"
                                  alt="img"
                                />
                                {course?.student_count} students enrolled
                              </p>
                            </>
                          )}
                          {course?.type === 'CBT' && (
                            <>
                              <p className="fw-medium d-flex align-items-center mb-0">
                                <ImageWithBasePath
                                  className="me-2"
                                  src="/assets/img/icons/book.svg"
                                  alt="img"
                                />
                                {course?.questions_count || '0'} Soal
                              </p>
                            </>
                          )}
                          <span className="badge badge-sm rounded-pill bg-warning fs-12">
                            {course?.category?.name}
                          </span>
                        </div>
                        <div className="d-sm-flex align-items-center justify-content-sm-between mt-3">
                          {course?.type === 'Course' && (
                            <>
                              <div className="d-flex mt-sm-0 mt-2 align-items-center">
                                <i className="fa-solid fa-star text-warning me-1" />
                                <i className="fa-solid fa-star text-warning me-1" />
                                <i className="fa-solid fa-star text-warning me-1" />
                                <i className="fa-solid fa-star text-warning me-1" />
                                <i className="fa-solid fa-star text-gray-1 me-1" />
                                <p className=" fs-14">
                                  <span className="text-gray-9">5.0</span>
                                </p>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            <div className="row mt-4">
              <div className="col-lg-8">
                <h2 className="breadcrumb-title mb-2">{course?.title}</h2>
                <div className="py-4">
                  <ImageWithBasePath
                    src=""
                    srcApi={course?.poster || course?.image}
                    alt="img"
                    className="img-fluid mb-4"
                    fallbackWidth={600}
                    fallbackHeight={300}
                  />
                </div>
                <div className="course-page-content pt-0">
                  <div className="card mb-4">
                    <div className="card-body">
                      <h5 className="mb-3">Overview</h5>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: course?.description,
                        }}
                      ></div>
                    </div>
                  </div>
                  {course?.type === 'Course' &&
                    course?.topics &&
                    course.topics.length > 0 && (
                      <>
                        <div className="card mb-4">
                          <div className="card-body">
                            <div className="d-flex justify-content-between flex-wrap">
                              <h5 className="subs-title mb-2 mb-sm-3">
                                Course Content
                              </h5>
                              <h6 className="fs-16 fw-medium text-gray-7 mb-3">
                                {course.topics.reduce(
                                  (total, topic) =>
                                    total + topic.lessons.length,
                                  0,
                                )}{' '}
                                Lectures{' '}
                                <span className="text-secondary">
                                  {course.topics.reduce((total, topic) => {
                                    const topicDuration = topic.lessons.reduce(
                                      (sum, lesson) => {
                                        // Extract duration from lesson description if available
                                        const duration =
                                          lesson.description || '00:00'
                                        return (
                                          sum + (duration !== '00:00' ? 1 : 0)
                                        ) // Count lessons with duration
                                      },
                                      0,
                                    )
                                    return total + topicDuration
                                  }, 0)}{' '}
                                  topics
                                </span>
                              </h6>
                            </div>
                            <div
                              className="accordion accordion-customicon1 accordions-items-seperate p-0"
                              id="accordioncustomicon1Example"
                            >
                              {course.topics.map((topic, topicIndex) => (
                                <div
                                  key={topic.id}
                                  className={`accordion-item ${
                                    topicIndex === course.topics.length - 1
                                      ? 'mb-0'
                                      : ''
                                  }`}
                                  data-aos="fade-up"
                                  data-aos-delay={topicIndex * 50}
                                >
                                  <h2
                                    className="accordion-header"
                                    id={`headingcustomicon1${topic.id}`}
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target={`#collapsecustomicon1${topic.id}`}
                                      aria-expanded="false"
                                      aria-controls={`collapsecustomicon1${topic.id}`}
                                    >
                                      {topic.name}{' '}
                                      <i className="fa-solid fa-chevron-down" />
                                    </button>
                                  </h2>
                                  <div
                                    id={`collapsecustomicon1${topic.id}`}
                                    className="accordion-collapse collapse"
                                    aria-labelledby={`headingcustomicon1${topic.id}`}
                                    data-bs-parent="#accordioncustomicon1Example"
                                  >
                                    <div className="accordion-body p-0">
                                      <ul>
                                        {topic.lessons.map(
                                          (lesson, lessonIndex) => (
                                            <li
                                              key={lesson.id}
                                              className={`p-4 px-3 d-flex justify-content-between ${
                                                lessonIndex ===
                                                topic.lessons.length - 1
                                                  ? 'pb-0'
                                                  : ''
                                              }`}
                                            >
                                              <p className="mb-0">
                                                <ImageWithBasePath
                                                  className="me-2"
                                                  src="/assets/img/icons/play.svg"
                                                  alt="img"
                                                />
                                                {lesson.name}
                                              </p>
                                              <div className="d-flex gap-xl-5 gap-3">
                                                {!lesson.is_premium && (
                                                  <Link
                                                    to="#"
                                                    className="preview-link"
                                                  >
                                                    Preview
                                                  </Link>
                                                )}
                                                <p className="mb-0">
                                                  {lesson.duration ||
                                                    '00:00'}
                                                </p>
                                              </div>
                                            </li>
                                          ),
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
              <div className="col-lg-4">
                <div className="course-sidebar-sec mt-0">
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2 className="text-success fs-30">
                          {calculateDiscount(
                            Number(course?.price),
                            course?.discount,
                            course?.discount_type,
                          )}
                        </h2>
                        <p className="fs-14 mb-0">
                          <span className="text-decoration-line-through me-2">
                            {rupiahFormatter(course?.price)}
                          </span>
                          {course?.discount_type === 'PERCENTAGE'
                            ? `${course?.discount}% off`
                            : `- ${rupiahFormatter(Number(course?.discount))}`}
                        </p>
                      </div>
                      <Link
                        to={
                          course?.is_bought
                            ? course?.type === 'Live_Teaching'
                              ? route.studentLiveEventDetails.replace(
                                  ':id',
                                  String(course.id),
                                )
                              : course?.type === 'CBT'
                              ? course?.is_answered
                                ? route.studentCBTList.replace(
                                    ':id',
                                    String(course.id),
                                  )
                                : route.studentCBTInstruction.replace(
                                    ':id',
                                    String(course.id),
                                  )
                              : route.studentCourseContent.replace(
                                  ':id',
                                  String(course.id),
                                )
                            : `${route.courseCheckout}?id=${course.id}`
                        }
                        className={`btn w-100 mt-3 btn-enroll ${
                          course?.type === 'CBT' && course?.is_answered
                            ? 'btn-success'
                            : 'btn-primary'
                        }`}
                      >
                        {(() => {
                          if (course?.type === 'Course') {
                            return course?.is_bought ? 'Akses Course' : 'Beli'
                          }
                          if (course?.type === 'Live_Teaching') {
                            return course?.is_bought ? 'Akses Kelas' : 'Daftar'
                          }
                          if (course?.type === 'CBT') {
                            if (course?.is_answered) {
                              return 'Lihat Review'
                            }
                            return course?.is_bought ? 'Mulai Ujian' : 'Daftar'
                          }
                          return 'Enroll Now'
                        })()}
                      </Link>
                    </div>
                  </div>
                  <div className="card mb-4">
                    {course?.benefits && course?.benefits.length > 0 && (
                      <>
                        <div className="card-body">
                          <h5 className="subs-title mb-4">Includes</h5>
                          {course?.benefits.map((item, index) => {
                            const iconObj = benefitsIcons.find(
                              (b) => b.value === item.icon,
                            )
                            const IconComponent = iconObj?.Icon
                            return (
                              <p className="mb-0" key={index}>
                                {IconComponent && (
                                  <IconComponent
                                    style={{
                                      color: iconObj.color,
                                      marginRight: 8,
                                    }}
                                  />
                                )}
                                {item?.name}
                              </p>
                            )
                          })}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="card mb-4">
                    {course?.studied && course?.studied.length > 0 && (
                      <>
                        <div className="card-body">
                          <h5 className="subs-title mb-4">
                            Apa yang dipelajari
                          </h5>
                          {course?.studied.map((item, index) => (
                            <p className="mb-0" key={index}>
                              <i className="fa-solid fa-check text-success me-2" />
                              {item}
                            </p>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* /Course detail */}
      </>
    </>
  )
}

export default CourseDetails
